import { inject, Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';

import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en';
import { TranslateService } from '@ngx-translate/core';

const CURRENT_LANGUAGE_KEY = 'OSCE_CURRENT_LANGUAGE';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    private _translateService = inject(TranslateService);

    public initLanguage() {
        registerLocaleData(localePl);
        registerLocaleData(localeEn);
        this._translateService.addLangs(['pl', 'en']);

        this.getCurrentLanguageFromStorage();
    }

    public getCurrentLanguageFromStorage() {
        const lang = localStorage.getItem(CURRENT_LANGUAGE_KEY) || 'pl';
        this._translateService.use(lang);
        return lang;
    }

    public getCurrentLanguageValue() {
        return this._translateService.getCurrentLang();
    }

    public changeLang(lang: string) {
        localStorage
            .setItem(CURRENT_LANGUAGE_KEY, lang);

        this._translateService.use(lang);
    }
}
